import { useCallback, useRef } from "react";
// @ts-ignore
import notificationAudioSrc from "../../../assets/audio/notification.mp3";

type UseNotificationAudioOptions = {
    src?: string;
    volume?: number;
};

const isAudioSupported = typeof Audio !== "undefined";

function useNotificationAudio(options: UseNotificationAudioOptions = {}) {
    const { src = notificationAudioSrc, volume = 1 } = options;
    const audioRef = useRef<HTMLAudioElement | null>(null);

    const playNotification = useCallback(() => {
        if (!isAudioSupported) {
            return;
        }

        if (!audioRef.current) {
            audioRef.current = new Audio(src);
            audioRef.current.preload = "auto";
        }

        const audio = audioRef.current;
        audio.volume = volume;
        audio.currentTime = 0;

        // Avoid unhandled promise rejections when browsers block autoplay
        void audio.play().catch(() => undefined);
    }, [src, volume]);

    return {
        playNotification,
    };
}

export default useNotificationAudio;
